import { Language } from '@/hooks/api/patients/types';
import { Picture } from '@/hooks/api/types';

export enum Role {
  ADMIN = 'ADMIN',
  MHP = 'MHP',
}

export interface Me {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  initials: string;
  photo?: Picture;
  profession?: string;
  academicTitle?: string;
  language?: Language;
  roles?: Array<Role>;
  twoFactorAuthRequired?: boolean;
}
